/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис предоставляет возможность управлять справочниками телеметрии
 */

/**
 * Сервис управления справочниками телеметрии.
 * Авторизация:
 *   - Authorization: Bearer token
 */
export class DictionaryServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения списка моделей ПУ.
   * Метод доступен для: Token: admin, service, application, bti, owner, employee, seller. Без учета разрешений
   */
  GetDictionaryDeviceModelList = (req?: GetDictionaryDeviceModelListRequestDto, init?: RequestInit): Promise<GetDictionaryDeviceModelListResponseDto[]> => {
    return fm.list<GetDictionaryDeviceModelListRequestDto, GetDictionaryDeviceModelListResponseDto>(`${this.host}/telemetry_control/api/v1/dictionary/device_model/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества моделей ПУ.
   * Метод доступен для: Token: admin, service, application, bti, owner, employee, seller. Без учета разрешений
   */
  GetDictionaryDeviceModelCount = (req?: GetDictionaryDeviceModelCountRequestDto, init?: RequestInit): Promise<GetDictionaryDeviceModelCountResponseDto> => {
    return fm.request<GetDictionaryDeviceModelCountRequestDto, GetDictionaryDeviceModelCountResponseDto>(`${this.host}/telemetry_control/api/v1/dictionary/device_model/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения модели ПУ.
   * Поддерживает создание и обновление.
   * Метод доступен для: Token: admin, service, application. Без учета разрешений
   */
  PostDictionaryDeviceModel = (req: PostDictionaryDeviceModelRequestDto, init?: RequestInit): Promise<PostDictionaryDeviceModelResponseDto> => {
    return fm.request<PostDictionaryDeviceModelRequestDto, PostDictionaryDeviceModelResponseDto>(`${this.host}/telemetry_control/api/v1/dictionary/device_model`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления модели ПУ.
   * Метод доступен для: Token: admin, service, application. Без учета разрешений
   */
  DeleteDictionaryDeviceModel = (req: DeleteDictionaryDeviceModelRequestDto, init?: RequestInit): Promise<DeleteDictionaryDeviceModelResponseDto> => {
    return fm.request<DeleteDictionaryDeviceModelRequestDto, DeleteDictionaryDeviceModelResponseDto>(`${this.host}/telemetry_control/api/v1/dictionary/device_model/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка элементов справочника Макрорегионы (МРФ).
   * Метод доступен для: Token: admin, service, application, bti, owner, employee, seller. Без учета разрешений
   */
  GetDictionaryMrfList = (req?: GetDictionaryMrfListRequestDto, init?: RequestInit): Promise<GetDictionaryMrfListResponseDto[]> => {
    return fm.list<GetDictionaryMrfListRequestDto, GetDictionaryMrfListResponseDto>(`${this.host}/telemetry_control/api/v1/dictionary/mrf/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества элементов справочника Макрорегионы (МРФ).
   * Метод доступен для: Token: admin, service, application, bti, owner, employee, seller. Без учета разрешений
   */
  GetDictionaryMrfCount = (req?: GetDictionaryMrfCountRequestDto, init?: RequestInit): Promise<GetDictionaryMrfCountResponseDto> => {
    return fm.request<GetDictionaryMrfCountRequestDto, GetDictionaryMrfCountResponseDto>(`${this.host}/telemetry_control/api/v1/dictionary/mrf/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка элементов справочника Регионы (РФ).
   * Метод доступен для: Token: admin, service, application, bti, owner, employee, seller. Без учета разрешений
   */
  GetDictionaryRfList = (req?: GetDictionaryRfListRequestDto, init?: RequestInit): Promise<GetDictionaryRfListResponseDto[]> => {
    return fm.list<GetDictionaryRfListRequestDto, GetDictionaryRfListResponseDto>(`${this.host}/telemetry_control/api/v1/dictionary/rf/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества элементов справочника Регионы (РФ).
   * Метод доступен для: Token: admin, service, application, bti, owner, employee, seller. Без учета разрешений
   */
  GetDictionaryRfCount = (req?: GetDictionaryRfCountRequestDto, init?: RequestInit): Promise<GetDictionaryRfCountResponseDto> => {
    return fm.request<GetDictionaryRfCountRequestDto, GetDictionaryRfCountResponseDto>(`${this.host}/telemetry_control/api/v1/dictionary/rf/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов направлений сортировки.
 * По умолчанию: ASC
 */
export enum DictionaryDeviceModelPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 * По умолчанию: ASC
 */
export type DictionaryDeviceModelPagingDirectionTypeResponseEnum = keyof typeof DictionaryDeviceModelPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 * По умолчанию: ASC
 */
export type DictionaryDeviceModelPagingDirectionTypeRequestEnum = Exclude<DictionaryDeviceModelPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки
 */
export enum DictionaryDeviceModelPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По заголовку элемента
   */
  TITLE = "TITLE",
}
/**
 * Справочник типов значений сортировки
 */
export type DictionaryDeviceModelPagingOrderByTypeResponseEnum = keyof typeof DictionaryDeviceModelPagingOrderByType
/**
 * Справочник типов значений сортировки
 */
export type DictionaryDeviceModelPagingOrderByTypeRequestEnum = Exclude<DictionaryDeviceModelPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник Макрорегионы (МРФ)
 */
export enum DictionaryMrfMrfType {
  /**
   * Значение не указано
   */
  MRF_TYPE_UNKNOWN = "MRF_TYPE_UNKNOWN",
  /**
   * Центр
   */
  TSENTR = "TSENTR",
  /**
   * Юг
   */
  YUG = "YUG",
  /**
   * Урал
   */
  URAL = "URAL",
  /**
   * Сибирь
   */
  SIBIR = "SIBIR",
  /**
   * Северо-Запад
   */
  SEVERO_ZAPAD = "SEVERO_ZAPAD",
  /**
   * Дальний Восток
   */
  DALNIY_VOSTOK = "DALNIY_VOSTOK",
  /**
   * Волга
   */
  VOLGA = "VOLGA",
}
/**
 * Справочник Макрорегионы (МРФ)
 */
export type DictionaryMrfMrfTypeResponseEnum = keyof typeof DictionaryMrfMrfType
/**
 * Справочник Макрорегионы (МРФ)
 */
export type DictionaryMrfMrfTypeRequestEnum = Exclude<DictionaryMrfMrfTypeResponseEnum, "MRF_TYPE_UNKNOWN">;

/**
 * Справочник Разрешения Телеметрии
 */
export enum DictionaryPermissionPermissionType {
  /**
   * Значение не указано
   */
  PERMISSION_TYPE_UNKNOWN = "PERMISSION_TYPE_UNKNOWN",
}
/**
 * Справочник Разрешения Телеметрии
 */
export type DictionaryPermissionPermissionTypeResponseEnum = keyof typeof DictionaryPermissionPermissionType
/**
 * Справочник Разрешения Телеметрии
 */
export type DictionaryPermissionPermissionTypeRequestEnum = Exclude<DictionaryPermissionPermissionTypeResponseEnum, "PERMISSION_TYPE_UNKNOWN">;

/**
 * Справочник Регионы (РФ)
 */
export enum DictionaryRfRfType {
  /**
   * Значение не указано
   */
  RF_TYPE_UNKNOWN = "RF_TYPE_UNKNOWN",
  /**
   * Республика Башкортостан
   */
  UFA = "UFA",
  /**
   * Кировская область
   */
  KIROV = "KIROV",
  /**
   * Ивановский филиал
   */
  IVANOVO = "IVANOVO",
  /**
   * Калужский филиал
   */
  KALUGA = "KALUGA",
  /**
   * Костромской филиал
   */
  KOSTROMA = "KOSTROMA",
  /**
   * Курский филиал
   */
  KURSK = "KURSK",
  /**
   * Липецкий филиал
   */
  LIPETSK = "LIPETSK",
  /**
   * Московская область
   */
  MOSOBLAST = "MOSOBLAST",
  /**
   * Орловский филиал
   */
  OREL = "OREL",
  /**
   * Рязанский филиал
   */
  RYAZAN = "RYAZAN",
  /**
   * Тамбовский филиал
   */
  TAMBOV = "TAMBOV",
  /**
   * Тверской филиал
   */
  TVER = "TVER",
  /**
   * Ярославский филиал
   */
  YAROSLAVL = "YAROSLAVL",
  /**
   * Смоленский филиал
   */
  SMOLENSK = "SMOLENSK",
  /**
   * Тульский филиал
   */
  TULA = "TULA",
  /**
   * Москва
   */
  MOSCOW = "MOSCOW",
  /**
   * ЕАО
   */
  EAO = "EAO",
  /**
   * Филиал в Тюменской и Курганской областях
   */
  KURGAN = "KURGAN",
  /**
   * Филиал в Тюменской и Курганской областях
   */
  TUMEN = "TUMEN",
  /**
   * Ханты-Мансийский филиал
   */
  HANTY = "HANTY",
  /**
   * Амурская область
   */
  AMUR = "AMUR",
  /**
   * Камчатский край
   */
  KAMCHATKA = "KAMCHATKA",
  /**
   * Магаданская область
   */
  MAGADAN = "MAGADAN",
  /**
   * Приморский край
   */
  PRIMORYE = "PRIMORYE",
  /**
   * Сахалинская область
   */
  SAKHALIN = "SAKHALIN",
  /**
   * Хабаровский край
   */
  KHABAROVSK = "KHABAROVSK",
  /**
   * Забайкальский край
   */
  CHITA = "CHITA",
  /**
   * ЧАО
   */
  CHUKOTKA = "CHUKOTKA",
  /**
   * Архангельск
   */
  ARCHANGELSK = "ARCHANGELSK",
  /**
   * Вологда
   */
  VOLOGDA = "VOLOGDA",
  /**
   * Калининград
   */
  KALININGRAD = "KALININGRAD",
  /**
   * Карелия
   */
  KARELIA = "KARELIA",
  /**
   * Коми
   */
  KOMI = "KOMI",
  /**
   * Лен область
   */
  LENOBLAST = "LENOBLAST",
  /**
   * Мурманск
   */
  MURMANSK = "MURMANSK",
  /**
   * Новгород
   */
  NOVGOROD = "NOVGOROD",
  /**
   * Псков
   */
  PSKOV = "PSKOV",
  /**
   * СПб
   */
  SPB = "SPB",
  /**
   * Алтайский филиал
   */
  ALTAI = "ALTAI",
  /**
   * Бурятский филиал
   */
  BURYATIYA = "BURYATIYA",
  /**
   * Иркутский филиал
   */
  IRKUTSK = "IRKUTSK",
  /**
   * Кемеровский филиал
   */
  KEMEROVO = "KEMEROVO",
  /**
   * Красноярский филиал
   */
  KRASNOYARSK = "KRASNOYARSK",
  /**
   * Омский филиал
   */
  OMSK = "OMSK",
  /**
   * Республика Хакасия
   */
  HAKASIYA = "HAKASIYA",
  /**
   * Республика Алтай
   */
  RALTAY = "RALTAY",
  /**
   * Республика Тыва
   */
  TUVA = "TUVA",
  /**
   * Томский филиал
   */
  TOMSK = "TOMSK",
  /**
   * Оренбургская область
   */
  ORENBURG = "ORENBURG",
  /**
   * Белгородский филиал
   */
  BELGOROD = "BELGOROD",
  /**
   * Саха
   */
  SAKHA = "SAKHA",
  /**
   * Екатеринбургский филиал
   */
  EKT = "EKT",
  /**
   * Волгоградский филиал
   */
  VOLGOGRAD = "VOLGOGRAD",
  /**
   * Ямало-Ненецкий филиал
   */
  YAMAL = "YAMAL",
  /**
   * Челябинский филиал
   */
  CHELYABINSK = "CHELYABINSK",
  /**
   * Пермский филиал ПАО \"Ростелеком\"
   */
  PERM = "PERM",
  /**
   * Республика Марий Эл
   */
  MARYEL = "MARYEL",
  /**
   * Пензенская область
   */
  PENZA = "PENZA",
  /**
   * Ингушский филиал
   */
  INGUSHETIA = "INGUSHETIA",
  /**
   * Кабардино-Балкарский филиал
   */
  NALCHIK = "NALCHIK",
  /**
   * Калмыцкий филиал
   */
  ELISTA = "ELISTA",
  /**
   * Ростовский филиал
   */
  ROSTOV = "ROSTOV",
  /**
   * Дагестанский филиал
   */
  MAHACHKALA = "MAHACHKALA",
  /**
   * Республика Мордовия
   */
  MORDOVIYA = "MORDOVIYA",
  /**
   * Республика Татарстан (Татарстан)
   */
  KAZAN = "KAZAN",
  /**
   * Самарская область
   */
  SAMARA = "SAMARA",
  /**
   * Саратовская область
   */
  SARATOV = "SARATOV",
  /**
   * Удмуртская Республика
   */
  UDMURTIYA = "UDMURTIYA",
  /**
   * Ульяновская область
   */
  ULYANOVSK = "ULYANOVSK",
  /**
   * Чувашская Республика - Чувашия
   */
  CHUVASHIYA = "CHUVASHIYA",
  /**
   * Нижегородская область
   */
  NNOVGOROD = "NNOVGOROD",
  /**
   * Брянский филиал
   */
  BRYANSK = "BRYANSK",
  /**
   * Владимирский филиал
   */
  VLADIMIR = "VLADIMIR",
  /**
   * Воронежский филиал
   */
  VORONEZH = "VORONEZH",
  /**
   * Северо-Осетинский филиал
   */
  VLADIKAVKAZ = "VLADIKAVKAZ",
  /**
   * Ставропольский филиал
   */
  STAVROPOL = "STAVROPOL",
  /**
   * Республика Карачаево-Черкесская
   */
  CHERKESSK = "CHERKESSK",
  /**
   * Республика Адыгея
   */
  MAYKOP = "MAYKOP",
  /**
   * Астраханский филиал
   */
  ASTRAKHAN = "ASTRAKHAN",
  /**
   * Краснодарский филиал
   */
  KRASNODAR = "KRASNODAR",
  /**
   * Тестовый
   */
  TEST = "TEST",
  /**
   * Новосибирский филиал
   */
  NOVOSIBIRSK = "NOVOSIBIRSK",
}
/**
 * Справочник Регионы (РФ)
 */
export type DictionaryRfRfTypeResponseEnum = keyof typeof DictionaryRfRfType
/**
 * Справочник Регионы (РФ)
 */
export type DictionaryRfRfTypeRequestEnum = Exclude<DictionaryRfRfTypeResponseEnum, "RF_TYPE_UNKNOWN">;

/**
 * Запрос удаления модели ПУ
 */
export type DeleteDictionaryDeviceModelRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос удаления модели ПУ
 */
export type DeleteDictionaryDeviceModelResponseDto = {
}
/**
 * Элемент справочника моделей ПУ
 */
export type DictionaryDeviceModelRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Модель счетчика
   */
  title?: string | null
  /**
   * Протокол счетчика
   */
  protocol?: string | null
  /**
   * Тип модели
   */
  modelKind?: string | null
}
/**
 * Элемент справочника моделей ПУ
 */
export type DictionaryDeviceModelResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Дата создания
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении
   */
  readonly changedAt: string
  /**
   * Модель счетчика
   */
  title: string | null
  /**
   * Протокол счетчика
   */
  protocol: string | null
  /**
   * Тип модели
   */
  modelKind: string | null
}
/**
 * Фильтр для запроса моделей приборов учета.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type DictionaryDeviceModelFilterRequestDto = {
  /**
   * По заголовку элемента
   */
  titles?: string[]
  /**
   * По типам модели
   */
  modelKinds?: string[]
}
/**
 * Фильтр для запроса моделей приборов учета.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type DictionaryDeviceModelFilterResponseDto = {
  /**
   * По заголовку элемента
   */
  titles: string[]
  /**
   * По типам модели
   */
  modelKinds: string[]
}
/**
 * Пагинация
 */
export type DictionaryDeviceModelPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType?: DictionaryDeviceModelPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: DictionaryDeviceModelPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано) то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация
 */
export type DictionaryDeviceModelPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: ID
   */
  orderByType: DictionaryDeviceModelPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: DictionaryDeviceModelPagingDirectionTypeResponseEnum
  /**
   * Количество.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано) то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Элемент справочника Макрорегионы (МРФ)
 */
export type DictionaryMrfRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Локализованный заголовок элемента
   */
  title?: string | null
  /**
   * Техническое наименование элемента
   */
  code?: string | null
}
/**
 * Элемент справочника Макрорегионы (МРФ)
 */
export type DictionaryMrfResponseDto = {
  /**
   * Идентификатор
   */
  readonly id: number
  /**
   * Дата создания
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении
   */
  readonly changedAt: string
  /**
   * Локализованный заголовок элемента
   */
  title: string | null
  /**
   * Техническое наименование элемента
   */
  code: string | null
}
/**
 * Элемент справочника Разрешения Телеметрии
 */
export type DictionaryPermissionRequestDto = {
  /**
   * Элемент справочника Разрешения Телеметрии
   */
  permissionType?: DictionaryPermissionPermissionTypeRequestEnum | "PERMISSION_TYPE_UNKNOWN"
}
/**
 * Элемент справочника Разрешения Телеметрии
 */
export type DictionaryPermissionResponseDto = {
  /**
   * Элемент справочника Разрешения Телеметрии
   */
  permissionType: DictionaryPermissionPermissionTypeResponseEnum
}
/**
 * Элемент справочника Регионы (РФ)
 */
export type DictionaryRfRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Локализованный заголовок элемента
   */
  title?: string | null
  /**
   * Техническое наименование элемента
   */
  code?: string | null
  /**
   * Принадлежность региона к Макрорегиону (МРФ)
   */
  mrfId: number
}
/**
 * Элемент справочника Регионы (РФ)
 */
export type DictionaryRfResponseDto = {
  /**
   * Идентификатор
   */
  readonly id: number
  /**
   * Дата создания
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении
   */
  readonly changedAt: string
  /**
   * Локализованный заголовок элемента
   */
  title: string | null
  /**
   * Техническое наименование элемента
   */
  code: string | null
  /**
   * Принадлежность региона к Макрорегиону (МРФ)
   */
  mrfId: number
}
/**
 * Запрос получения количества моделей приборов учета
 */
export type GetDictionaryDeviceModelCountRequestDto = {
  /**
   * Фильтр по моделям приборов учета
   */
  filter?: DictionaryDeviceModelFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества моделей приборов учета
 */
export type GetDictionaryDeviceModelCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего моделей приборов учета
   */
  readonly data: number
}>
/**
 * Запрос получения списка моделей ПУ
 */
export type GetDictionaryDeviceModelListRequestDto = {
  /**
   * Фильтр
   */
  filter?: DictionaryDeviceModelFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: DictionaryDeviceModelPagingRequestDto
}>
/**
 * Ответ на запрос получения списка моделей приборов учета
 */
export type GetDictionaryDeviceModelListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Элемент справочника моделей ПУ
   */
  readonly data: DictionaryDeviceModelResponseDto
}>
/**
 * Запрос получения модели ПУ
 */
export type GetDictionaryDeviceModelRequestDto = {
  /**
   * Идентификатор модели ПУ
   */
  id: number
}
/**
 * Ответ на запрос получения модели ПУ
 */
export type GetDictionaryDeviceModelResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Элемент справочника моделей
   */
  readonly data: DictionaryDeviceModelResponseDto
}>
/**
 * Запрос получения количества элементов справочника Макрорегионы (МРФ)
 */
export type GetDictionaryMrfCountRequestDto = {
}
/**
 * Ответ на запрос получения количества элементов справочника Макрорегионы (МРФ)
 */
export type GetDictionaryMrfCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего элементов справочника Макрорегионы (МРФ)
   */
  readonly data: number
}>
/**
 * Запрос получения элементов справочника Макрорегионы (МРФ)
 */
export type GetDictionaryMrfListRequestDto = {
}
/**
 * Ответ на запрос получения элементов справочника Макрорегионы (МРФ)
 */
export type GetDictionaryMrfListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Элемент справочника Макрорегионы (МРФ)
   */
  readonly data: DictionaryMrfResponseDto
}>
/**
 * Запрос получения количества элементов справочника Регионы (РФ)
 */
export type GetDictionaryRfCountRequestDto = {
}
/**
 * Ответ на запрос получения количества элементов справочника Регионы (РФ)
 */
export type GetDictionaryRfCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего элементов справочника Регионы (РФ)
   */
  readonly data: number
}>
/**
 * Запрос получения элементов справочника Регионы (РФ)
 */
export type GetDictionaryRfListRequestDto = {
}
/**
 * Ответ на запрос получения элементов справочника Регионы (РФ)
 */
export type GetDictionaryRfListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Элемент справочника Регионы (РФ)
   */
  readonly data: DictionaryRfResponseDto
}>
/**
 * Запрос сохранения модели ПУ
 */
export type PostDictionaryDeviceModelRequestDto = {
  /**
   * Шаблон ПУ
   */
  data: DictionaryDeviceModelRequestDto
}
/**
 * Ответ на запрос сохранения модели ПУ
 */
export type PostDictionaryDeviceModelResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон ПУ
   */
  readonly data: DictionaryDeviceModelResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления модели ПУ
   */
  "DeleteDictionaryDeviceModelRequest": {
    "kind": "class",
    "text": "Запрос удаления модели ПУ",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления модели ПУ
   */
  "DeleteDictionaryDeviceModelResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления модели ПУ",
  },
  /**
   * Элемент справочника моделей ПУ
   */
  "DictionaryDeviceModel": {
    "kind": "class",
    "text": "Элемент справочника моделей ПУ",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Дата создания
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении",
      },
      /**
       * Модель счетчика
       */
      "title": {
        "type": "google.protobuf.StringValue",
        "text": "Модель счетчика",
      },
      /**
       * Протокол счетчика
       */
      "protocol": {
        "type": "google.protobuf.StringValue",
        "text": "Протокол счетчика",
      },
      /**
       * Тип модели
       */
      "modelKind": {
        "type": "google.protobuf.StringValue",
        "text": "Тип модели",
      },
    },
  },
  /**
   * Фильтр для запроса моделей приборов учета.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "DictionaryDeviceModelFilter": {
    "kind": "class",
    "text": "Фильтр для запроса моделей приборов учета.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По заголовку элемента
       */
      "titles": {
        "type": "string",
        "text": "По заголовку элемента",
      },
      /**
       * По типам модели
       */
      "modelKinds": {
        "type": "string",
        "text": "По типам модели",
      },
    },
  },
  /**
   * Пагинация
   */
  "DictionaryDeviceModelPaging": {
    "kind": "class",
    "text": "Пагинация",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: ID
       */
      "orderByType": {
        "type": "DictionaryDeviceModelPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "DictionaryDeviceModelPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано) то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано) то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Элемент справочника Макрорегионы (МРФ)
   */
  "DictionaryMrf": {
    "kind": "class",
    "text": "Элемент справочника Макрорегионы (МРФ)",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Дата создания
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении",
      },
      /**
       * Локализованный заголовок элемента
       */
      "title": {
        "type": "google.protobuf.StringValue",
        "text": "Локализованный заголовок элемента",
      },
      /**
       * Техническое наименование элемента
       */
      "code": {
        "type": "google.protobuf.StringValue",
        "text": "Техническое наименование элемента",
      },
    },
  },
  /**
   * Элемент справочника Разрешения Телеметрии
   */
  "DictionaryPermission": {
    "kind": "class",
    "text": "Элемент справочника Разрешения Телеметрии",
    "fields": {
      /**
       * Элемент справочника Разрешения Телеметрии
       */
      "permissionType": {
        "type": "DictionaryPermission.PermissionType",
        "text": "Элемент справочника Разрешения Телеметрии",
      },
    },
  },
  /**
   * Элемент справочника Регионы (РФ)
   */
  "DictionaryRf": {
    "kind": "class",
    "text": "Элемент справочника Регионы (РФ)",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Дата создания
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении",
      },
      /**
       * Локализованный заголовок элемента
       */
      "title": {
        "type": "google.protobuf.StringValue",
        "text": "Локализованный заголовок элемента",
      },
      /**
       * Техническое наименование элемента
       */
      "code": {
        "type": "google.protobuf.StringValue",
        "text": "Техническое наименование элемента",
      },
      /**
       * Принадлежность региона к Макрорегиону (МРФ)
       */
      "mrfId": {
        "type": "int32",
        "text": "Принадлежность региона к Макрорегиону (МРФ)",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Запрос получения количества моделей приборов учета
   */
  "GetDictionaryDeviceModelCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества моделей приборов учета",
    "fields": {
      /**
       * Фильтр по моделям приборов учета
       */
      "filter": {
        "type": "DictionaryDeviceModelFilter",
        "text": "Фильтр по моделям приборов учета",
      },
    },
  },
  /**
   * Ответ на запрос получения количества моделей приборов учета
   */
  "GetDictionaryDeviceModelCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества моделей приборов учета",
    "fields": {
      /**
       * Всего моделей приборов учета
       */
      "data": {
        "type": "int32",
        "text": "Всего моделей приборов учета",
      },
    },
  },
  /**
   * Запрос получения списка моделей ПУ
   */
  "GetDictionaryDeviceModelListRequest": {
    "kind": "class",
    "text": "Запрос получения списка моделей ПУ",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "DictionaryDeviceModelFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "DictionaryDeviceModelPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка моделей приборов учета
   */
  "GetDictionaryDeviceModelListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка моделей приборов учета",
    "fields": {
      /**
       * Элемент справочника моделей ПУ
       */
      "data": {
        "type": "DictionaryDeviceModel",
        "text": "Элемент справочника моделей ПУ",
      },
    },
  },
  /**
   * Запрос получения модели ПУ
   */
  "GetDictionaryDeviceModelRequest": {
    "kind": "class",
    "text": "Запрос получения модели ПУ",
    "fields": {
      /**
       * Идентификатор модели ПУ
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор модели ПУ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения модели ПУ
   */
  "GetDictionaryDeviceModelResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения модели ПУ",
    "fields": {
      /**
       * Элемент справочника моделей
       */
      "data": {
        "type": "DictionaryDeviceModel",
        "text": "Элемент справочника моделей",
      },
    },
  },
  /**
   * Запрос получения количества элементов справочника Макрорегионы (МРФ)
   */
  "GetDictionaryMrfCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества элементов справочника Макрорегионы (МРФ)",
  },
  /**
   * Ответ на запрос получения количества элементов справочника Макрорегионы (МРФ)
   */
  "GetDictionaryMrfCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества элементов справочника Макрорегионы (МРФ)",
    "fields": {
      /**
       * Всего элементов справочника Макрорегионы (МРФ)
       */
      "data": {
        "type": "int32",
        "text": "Всего элементов справочника Макрорегионы (МРФ)",
      },
    },
  },
  /**
   * Запрос получения элементов справочника Макрорегионы (МРФ)
   */
  "GetDictionaryMrfListRequest": {
    "kind": "class",
    "text": "Запрос получения элементов справочника Макрорегионы (МРФ)",
  },
  /**
   * Ответ на запрос получения элементов справочника Макрорегионы (МРФ)
   */
  "GetDictionaryMrfListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения элементов справочника Макрорегионы (МРФ)",
    "fields": {
      /**
       * Элемент справочника Макрорегионы (МРФ)
       */
      "data": {
        "type": "DictionaryMrf",
        "text": "Элемент справочника Макрорегионы (МРФ)",
      },
    },
  },
  /**
   * Запрос получения количества элементов справочника Регионы (РФ)
   */
  "GetDictionaryRfCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества элементов справочника Регионы (РФ)",
  },
  /**
   * Ответ на запрос получения количества элементов справочника Регионы (РФ)
   */
  "GetDictionaryRfCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества элементов справочника Регионы (РФ)",
    "fields": {
      /**
       * Всего элементов справочника Регионы (РФ)
       */
      "data": {
        "type": "int32",
        "text": "Всего элементов справочника Регионы (РФ)",
      },
    },
  },
  /**
   * Запрос получения элементов справочника Регионы (РФ)
   */
  "GetDictionaryRfListRequest": {
    "kind": "class",
    "text": "Запрос получения элементов справочника Регионы (РФ)",
  },
  /**
   * Ответ на запрос получения элементов справочника Регионы (РФ)
   */
  "GetDictionaryRfListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения элементов справочника Регионы (РФ)",
    "fields": {
      /**
       * Элемент справочника Регионы (РФ)
       */
      "data": {
        "type": "DictionaryRf",
        "text": "Элемент справочника Регионы (РФ)",
      },
    },
  },
  /**
   * Запрос сохранения модели ПУ
   */
  "PostDictionaryDeviceModelRequest": {
    "kind": "class",
    "text": "Запрос сохранения модели ПУ",
    "fields": {
      /**
       * Шаблон ПУ
       */
      "data": {
        "type": "DictionaryDeviceModel",
        "text": "Шаблон ПУ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения модели ПУ
   */
  "PostDictionaryDeviceModelResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения модели ПУ",
    "fields": {
      /**
       * Шаблон ПУ
       */
      "data": {
        "type": "DictionaryDeviceModel",
        "text": "Шаблон ПУ",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   * По умолчанию: ASC
   */
  "DictionaryDeviceModelPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.\nПо умолчанию: ASC",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки
   */
  "DictionaryDeviceModelPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По заголовку элемента
       */
      "TITLE": {
        "i": 2,
        "text": "По заголовку элемента",
      },
    },
  },
  /**
   * Справочник Макрорегионы (МРФ)
   */
  "DictionaryMrf.MrfType": {
    "kind": "enum",
    "text": "Справочник Макрорегионы (МРФ)",
    "values": {
      /**
       * Значение не указано
       */
      "MRF_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Центр
       */
      "TSENTR": {
        "i": 1,
        "text": "Центр",
      },
      /**
       * Юг
       */
      "YUG": {
        "i": 2,
        "text": "Юг",
      },
      /**
       * Урал
       */
      "URAL": {
        "i": 3,
        "text": "Урал",
      },
      /**
       * Сибирь
       */
      "SIBIR": {
        "i": 4,
        "text": "Сибирь",
      },
      /**
       * Северо-Запад
       */
      "SEVERO_ZAPAD": {
        "i": 5,
        "text": "Северо-Запад",
      },
      /**
       * Дальний Восток
       */
      "DALNIY_VOSTOK": {
        "i": 6,
        "text": "Дальний Восток",
      },
      /**
       * Волга
       */
      "VOLGA": {
        "i": 7,
        "text": "Волга",
      },
    },
  },
  /**
   * Справочник Разрешения Телеметрии
   */
  "DictionaryPermission.PermissionType": {
    "kind": "enum",
    "text": "Справочник Разрешения Телеметрии",
    "values": {
      /**
       * Значение не указано
       */
      "PERMISSION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
    },
  },
  /**
   * Справочник Регионы (РФ)
   */
  "DictionaryRf.RfType": {
    "kind": "enum",
    "text": "Справочник Регионы (РФ)",
    "values": {
      /**
       * Значение не указано
       */
      "RF_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Республика Башкортостан
       */
      "UFA": {
        "i": 1,
        "text": "Республика Башкортостан",
      },
      /**
       * Кировская область
       */
      "KIROV": {
        "i": 2,
        "text": "Кировская область",
      },
      /**
       * Ивановский филиал
       */
      "IVANOVO": {
        "i": 3,
        "text": "Ивановский филиал",
      },
      /**
       * Калужский филиал
       */
      "KALUGA": {
        "i": 4,
        "text": "Калужский филиал",
      },
      /**
       * Костромской филиал
       */
      "KOSTROMA": {
        "i": 5,
        "text": "Костромской филиал",
      },
      /**
       * Курский филиал
       */
      "KURSK": {
        "i": 6,
        "text": "Курский филиал",
      },
      /**
       * Липецкий филиал
       */
      "LIPETSK": {
        "i": 7,
        "text": "Липецкий филиал",
      },
      /**
       * Московская область
       */
      "MOSOBLAST": {
        "i": 8,
        "text": "Московская область",
      },
      /**
       * Орловский филиал
       */
      "OREL": {
        "i": 9,
        "text": "Орловский филиал",
      },
      /**
       * Рязанский филиал
       */
      "RYAZAN": {
        "i": 10,
        "text": "Рязанский филиал",
      },
      /**
       * Тамбовский филиал
       */
      "TAMBOV": {
        "i": 11,
        "text": "Тамбовский филиал",
      },
      /**
       * Тверской филиал
       */
      "TVER": {
        "i": 12,
        "text": "Тверской филиал",
      },
      /**
       * Ярославский филиал
       */
      "YAROSLAVL": {
        "i": 13,
        "text": "Ярославский филиал",
      },
      /**
       * Смоленский филиал
       */
      "SMOLENSK": {
        "i": 14,
        "text": "Смоленский филиал",
      },
      /**
       * Тульский филиал
       */
      "TULA": {
        "i": 15,
        "text": "Тульский филиал",
      },
      /**
       * Москва
       */
      "MOSCOW": {
        "i": 16,
        "text": "Москва",
      },
      /**
       * ЕАО
       */
      "EAO": {
        "i": 17,
        "text": "ЕАО",
      },
      /**
       * Филиал в Тюменской и Курганской областях
       */
      "KURGAN": {
        "i": 18,
        "text": "Филиал в Тюменской и Курганской областях",
      },
      /**
       * Филиал в Тюменской и Курганской областях
       */
      "TUMEN": {
        "i": 19,
        "text": "Филиал в Тюменской и Курганской областях",
      },
      /**
       * Ханты-Мансийский филиал
       */
      "HANTY": {
        "i": 20,
        "text": "Ханты-Мансийский филиал",
      },
      /**
       * Амурская область
       */
      "AMUR": {
        "i": 21,
        "text": "Амурская область",
      },
      /**
       * Камчатский край
       */
      "KAMCHATKA": {
        "i": 22,
        "text": "Камчатский край",
      },
      /**
       * Магаданская область
       */
      "MAGADAN": {
        "i": 23,
        "text": "Магаданская область",
      },
      /**
       * Приморский край
       */
      "PRIMORYE": {
        "i": 24,
        "text": "Приморский край",
      },
      /**
       * Сахалинская область
       */
      "SAKHALIN": {
        "i": 25,
        "text": "Сахалинская область",
      },
      /**
       * Хабаровский край
       */
      "KHABAROVSK": {
        "i": 26,
        "text": "Хабаровский край",
      },
      /**
       * Забайкальский край
       */
      "CHITA": {
        "i": 27,
        "text": "Забайкальский край",
      },
      /**
       * ЧАО
       */
      "CHUKOTKA": {
        "i": 28,
        "text": "ЧАО",
      },
      /**
       * Архангельск
       */
      "ARCHANGELSK": {
        "i": 29,
        "text": "Архангельск",
      },
      /**
       * Вологда
       */
      "VOLOGDA": {
        "i": 30,
        "text": "Вологда",
      },
      /**
       * Калининград
       */
      "KALININGRAD": {
        "i": 31,
        "text": "Калининград",
      },
      /**
       * Карелия
       */
      "KARELIA": {
        "i": 32,
        "text": "Карелия",
      },
      /**
       * Коми
       */
      "KOMI": {
        "i": 33,
        "text": "Коми",
      },
      /**
       * Лен область
       */
      "LENOBLAST": {
        "i": 34,
        "text": "Лен область",
      },
      /**
       * Мурманск
       */
      "MURMANSK": {
        "i": 35,
        "text": "Мурманск",
      },
      /**
       * Новгород
       */
      "NOVGOROD": {
        "i": 36,
        "text": "Новгород",
      },
      /**
       * Псков
       */
      "PSKOV": {
        "i": 37,
        "text": "Псков",
      },
      /**
       * СПб
       */
      "SPB": {
        "i": 38,
        "text": "СПб",
      },
      /**
       * Алтайский филиал
       */
      "ALTAI": {
        "i": 39,
        "text": "Алтайский филиал",
      },
      /**
       * Бурятский филиал
       */
      "BURYATIYA": {
        "i": 40,
        "text": "Бурятский филиал",
      },
      /**
       * Иркутский филиал
       */
      "IRKUTSK": {
        "i": 41,
        "text": "Иркутский филиал",
      },
      /**
       * Кемеровский филиал
       */
      "KEMEROVO": {
        "i": 42,
        "text": "Кемеровский филиал",
      },
      /**
       * Красноярский филиал
       */
      "KRASNOYARSK": {
        "i": 43,
        "text": "Красноярский филиал",
      },
      /**
       * Омский филиал
       */
      "OMSK": {
        "i": 44,
        "text": "Омский филиал",
      },
      /**
       * Республика Хакасия
       */
      "HAKASIYA": {
        "i": 45,
        "text": "Республика Хакасия",
      },
      /**
       * Республика Алтай
       */
      "RALTAY": {
        "i": 46,
        "text": "Республика Алтай",
      },
      /**
       * Республика Тыва
       */
      "TUVA": {
        "i": 47,
        "text": "Республика Тыва",
      },
      /**
       * Томский филиал
       */
      "TOMSK": {
        "i": 48,
        "text": "Томский филиал",
      },
      /**
       * Оренбургская область
       */
      "ORENBURG": {
        "i": 49,
        "text": "Оренбургская область",
      },
      /**
       * Белгородский филиал
       */
      "BELGOROD": {
        "i": 50,
        "text": "Белгородский филиал",
      },
      /**
       * Саха
       */
      "SAKHA": {
        "i": 51,
        "text": "Саха",
      },
      /**
       * Екатеринбургский филиал
       */
      "EKT": {
        "i": 52,
        "text": "Екатеринбургский филиал",
      },
      /**
       * Волгоградский филиал
       */
      "VOLGOGRAD": {
        "i": 53,
        "text": "Волгоградский филиал",
      },
      /**
       * Ямало-Ненецкий филиал
       */
      "YAMAL": {
        "i": 54,
        "text": "Ямало-Ненецкий филиал",
      },
      /**
       * Челябинский филиал
       */
      "CHELYABINSK": {
        "i": 55,
        "text": "Челябинский филиал",
      },
      /**
       * Пермский филиал ПАО \"Ростелеком\"
       */
      "PERM": {
        "i": 56,
        "text": "Пермский филиал ПАО \"Ростелеком\"",
      },
      /**
       * Республика Марий Эл
       */
      "MARYEL": {
        "i": 57,
        "text": "Республика Марий Эл",
      },
      /**
       * Пензенская область
       */
      "PENZA": {
        "i": 58,
        "text": "Пензенская область",
      },
      /**
       * Ингушский филиал
       */
      "INGUSHETIA": {
        "i": 59,
        "text": "Ингушский филиал",
      },
      /**
       * Кабардино-Балкарский филиал
       */
      "NALCHIK": {
        "i": 60,
        "text": "Кабардино-Балкарский филиал",
      },
      /**
       * Калмыцкий филиал
       */
      "ELISTA": {
        "i": 61,
        "text": "Калмыцкий филиал",
      },
      /**
       * Ростовский филиал
       */
      "ROSTOV": {
        "i": 62,
        "text": "Ростовский филиал",
      },
      /**
       * Дагестанский филиал
       */
      "MAHACHKALA": {
        "i": 63,
        "text": "Дагестанский филиал",
      },
      /**
       * Республика Мордовия
       */
      "MORDOVIYA": {
        "i": 64,
        "text": "Республика Мордовия",
      },
      /**
       * Республика Татарстан (Татарстан)
       */
      "KAZAN": {
        "i": 65,
        "text": "Республика Татарстан (Татарстан)",
      },
      /**
       * Самарская область
       */
      "SAMARA": {
        "i": 66,
        "text": "Самарская область",
      },
      /**
       * Саратовская область
       */
      "SARATOV": {
        "i": 67,
        "text": "Саратовская область",
      },
      /**
       * Удмуртская Республика
       */
      "UDMURTIYA": {
        "i": 68,
        "text": "Удмуртская Республика",
      },
      /**
       * Ульяновская область
       */
      "ULYANOVSK": {
        "i": 69,
        "text": "Ульяновская область",
      },
      /**
       * Чувашская Республика - Чувашия
       */
      "CHUVASHIYA": {
        "i": 70,
        "text": "Чувашская Республика - Чувашия",
      },
      /**
       * Нижегородская область
       */
      "NNOVGOROD": {
        "i": 71,
        "text": "Нижегородская область",
      },
      /**
       * Брянский филиал
       */
      "BRYANSK": {
        "i": 72,
        "text": "Брянский филиал",
      },
      /**
       * Владимирский филиал
       */
      "VLADIMIR": {
        "i": 73,
        "text": "Владимирский филиал",
      },
      /**
       * Воронежский филиал
       */
      "VORONEZH": {
        "i": 74,
        "text": "Воронежский филиал",
      },
      /**
       * Северо-Осетинский филиал
       */
      "VLADIKAVKAZ": {
        "i": 75,
        "text": "Северо-Осетинский филиал",
      },
      /**
       * Ставропольский филиал
       */
      "STAVROPOL": {
        "i": 76,
        "text": "Ставропольский филиал",
      },
      /**
       * Республика Карачаево-Черкесская
       */
      "CHERKESSK": {
        "i": 77,
        "text": "Республика Карачаево-Черкесская",
      },
      /**
       * Республика Адыгея
       */
      "MAYKOP": {
        "i": 78,
        "text": "Республика Адыгея",
      },
      /**
       * Астраханский филиал
       */
      "ASTRAKHAN": {
        "i": 79,
        "text": "Астраханский филиал",
      },
      /**
       * Краснодарский филиал
       */
      "KRASNODAR": {
        "i": 80,
        "text": "Краснодарский филиал",
      },
      /**
       * Тестовый
       */
      "TEST": {
        "i": 81,
        "text": "Тестовый",
      },
      /**
       * Новосибирский филиал
       */
      "NOVOSIBIRSK": {
        "i": 82,
        "text": "Новосибирский филиал",
      },
    },
  },
}